import React, { useState, useEffect, useDebugValue } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import styles from "assets/jss/material-kit-react/views/tour.js";
import useScript from 'components/useScript/index';
import { Helmet } from 'react-helmet'

const useStyles = makeStyles(styles);

export default function TopDevMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    useScript("https://www.aparat.com/embed/fvrlL?data[rnddiv]=47549003146&data[responsive]=yes")
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Helmet>
                <title>کمپ آموزشی شریف | تور مجازی ترنج</title>
                <meta name="description" content="نمایشگاه مجازی ترنج، امکان ساخت و مدیریت آنلاین نمایشگاه مجازی را فراهم آورده و با استفاده از پنل قدرتمند شما را قادر میکند متناسب با کسب و کار خود به ساده ترین شکل ممکن نمایشگاه مجازی بسازید." />
                <meta name="" content="نمایشگاه مجازی ترنج, نمایشگاه مجازی, پانوراما، تور مجازی، نمایشگاه سه بعدی" />
            </Helmet>
            <Parallax small filter image={require("assets/img/bg15.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={"/assets/images/tour.jpg"} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>تور و نمایشگاه مجازی ترنج</h3>
                                        <div className={classes.description}>
                                            <p>
                                                برگزاری نمایشگاه‌های مجازی یکی از بهترین فرصت‌ها برای صاحبان کسب و کار است تا با بهره گیری از فناوری به روز و کارآمد اطلاع رسانی چندرسانه‌ای، محصولات و خدمات خود را به شکل نامحدود به مخاطبان عرضه نمایند. هر آنچه که در نمایشگاه‌های فیزیکی دارای محدودیت و هزینه ساز است در نمایشگاه‌های مجازی وجود ندارد. محدودیت در زمان و مکان، هزینه‌های سنگین اجاره فضا، تجهیزات، حمل و نقل، دکوراسیون، چاپ و تبلیغات محیطی، دوری از محل شرکت یا کسب و کار، از یاد رفتن خدمات و محصولات از ذهن مشتریان پرزنت شده پس از گذشت زمان و... هیچ یک در نمایشگاه های مجازی دائمی وجود نداشته و مخاطبان در هر زمان و مکان می‌توانند محصولات یا خدمات کسب و کارها و مشاغل را مشاهده و بررسی کنند و با دیگران به اشتراک بگذارند.
                                            </p>
                                        </div>
                                        <div>
                                            <br />
                                            <p>
                                                <Button variant="outlined" target='_blank' color="secondary" href="https://Tpan.ir" disableElevation>
                                                    سامانه ساخت و مدیریت نمایشگاه و تور مجازی ترنج (TPAN.ir)
                                                </Button>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                            <div>
                                            <iframe src="https://tpan.ir/tour/home/firstpage/true" width="100%" height="600" frameborder="no" scrolling="no" allow="accelerometer; autoplay; gyroscope" allowfullscreen></iframe>
                                        </div>
                            </GridItem>
                            </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>معرفی نمایشگاه مجازی</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        راهکاری‌های زیادی برای ایجاد و ارائه نمایشگاه های مجازی وجود دارد. اما مطمئنا کسب و کارهای خلاق و پیشرو همواره به دنبال ظاهر خلاق و سفارشی، امکانات گسترده و قابل توسعه و توان فنی و پشتیبانی مناسب در کنار خود هستند.
                                    </p>
                                    <p>
                                        این نمایشگاه 24*7 و بدون محدودیت زمانی ارائه دهنده خدمات خواهد بود. سرورها در درون کشور هستند و تحریم های روی آن تاثیری ندارد. برای استفاده از نمایشگاه مجازی ترنج نیاز به نصب هیچ ابزاری نیست. اکثر مرورگرها بدون هیچ مشکلی نمایشگاه را پشتیبانی می کنند. فایلهای دانلود شده کم حجم هستند و نسخه سبک نمایشگاه قابل ارائه است بدین معنی که روی موبایل که اندازه صفحه کوچکتری دارد، نسخه کم حجم تر نمایشگاه بار گزاری می‌شود.
                                    </p>
                                    <p>
                                        سرعت اجرای بالا، نمایش مناسب روی موبایل، تبلت، تلویزیون و سایر دستگاه ها، ارائه آمار و اطلاعات تفکیکی از حضور افراد در غرفه ها، ارائه انواع کلیپ‌های ویدیویی، عکس‌های ثابت و گالری عکس، گفتار صوتی، نقشه و پلان، اطلاعات متنی، نظر سنجی، نمایش صفحات وب در نمایشگاه مجازی، لینک به سبد خرید فروشگاه‌های آنلاین، نمایش انواع نمودار، چارت، اینفوگرافی، قابلیت جایگذاری انواع کاتالوگ و بروشور همراه با امکان دانلود، نمایش چندگانه ایستگاه‌ها به صورت نمایش روز، شب، بالا، دید ناظر زمینی، کارتونی و ... و فراخوانی وب سرویس های مختلف و نمایش اطلاعات دریافتی در نمایشگاه تنها بخشی از امکانات نمایشگاه مجازی ترنج است.
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.center}>
                                    <img className={classes.image} src="/assets/images/tour-first.jpg" />
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>مزایای بازدید از نمایشگاه مجازی</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        بازدید از نمایشگاه مجازی برای بازدیدکنندگان داری جذابیت زیادی خواهد بود؛
                                    </p>
                                    <p>
                                        توجه به این نکته لازم است که نمایشگاه ها همواره مخاطبین خاص و حرفه ای خود را دارند که در هر شرایطی  در نمایشگاه شرکت خواهند کرد، اما بازدید کنندگان عمومی نیز بخش زیادی از مخاطبین نمایشگاه هستند و
                                        توجه به راحتی این افراد برای حضور در نمایشگاه امری بسیار واجب است.</p>
                                    <p>
                                        بازدید از نمایشگاه همواره دارای هزینه هایی بوده است، که مهمترین آن دوری بازدید کننده از محل نمایشگاه و مدت زمان محدود برگزاری آن می باشد.
                                    </p>
                                    <p>
                                        این مشکلات و هزینه ها در نمایشگاه مجازی به صورت کامل رفع شده است؛ علاوه بر این مورد، از دیگر مزایای مهم حضور در نمایشگاه مجازی برای بازدیدکنندگان، میتوان به موارد زیر اشاره کرد:
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.center}>
                                    <img className={classes.image} src="/assets/images/tour-2.jpg" />
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>امکانات</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        <ul>
                                            <li>محیط سه بعدی با تصاویر اختصاصی از محیط کسب و کار شما (عکاسی اختصاصی)</li>
                                            <li>نمایش فضای باز و فضای داخلی</li>
                                            <li>نمایش از دید ناظر زمینی، نمایش از ارتفاع (مناسب کارخانه ها)</li>
                                            <li>لندینگ پیج</li>
                                            <li>ادیت تصاویر قبل از اجرا (اضافه کردن استند، بنر، تابلو و ...)</li>
                                            <li>تغییر رویداد محور تصاویر روی دیوار&nbsp;</li>
                                            <li>نمایش تصاویر جداگانه برای روز و شب</li>
                                            <li>گالری تصاویر، با کپشن برای هر عکس</li>
                                            <li>اشاره گر به محتوای صفحه</li>
                                            <li>آیکون ها و علایم مختلف</li>
                                            <li>معرفی محصولات با تصویر</li>
                                            <li>نمایش متن، عکس و ویدیو</li>
                                            <li>رادیو نمایشگاه (تفکیک غرفه ها، راهرو و ...)</li>
                                            <li>ایجاد دسته بندی کاتالوگ، بروشور و راهنما</li>
                                            <li>ارتباط با پشتیبان غرفه</li>
                                            <li>ارائه آمار تفکیکی</li>
                                            <li>دامین اختصاصی و آدرس یکتا برای هر غرفه و لینک کوتاه</li>
                                            <li>دسترسی سریع به غرفه ها از منوی کشویی</li>
                                            <li>نمایش ویدیو دیواری</li>
                                            <li>نمایش صفحات وب در همان صفحه</li>
                                            <li>منوی سفارشی (به تفکیک هر راهرو و غرفه)</li>
                                            <li>لینک وبسایت غرفه، اینستاگرام، لینکدین و ...</li>
                                            <li>نمایش اخبار فوری</li>
                                            <li>بزرگنمایی و کوچک نمایی</li>
                                            <li>نمایش تمام صفحه</li>
                                            <li>امکان درج متن برای معرفی هر غرفه، اثر یا تصاویر گالری</li>
                                            <li>امکان درج و نمایش فایل <span dir="LTR">pdf</span></li>
                                            <li>برگزاری مسابقه، بازی و سرگرمی</li>
                                            <li>برگزاری جلسات خصوصی به صورت آنلاین</li>
                                            <li>ارائه فرصت های شغلی و دریافت رزومه</li>
                                            <li>بارگزاری سریع</li>
                                            <li>بارگزاری تصاویر غرفه با نمایش روند پیشرفت</li>
                                            <li>نمایش مناسب روی موبایل</li>
                                            <li>فراخوانی وب سرویس های اختصاصی، درگاه بانک و ... به صورت سفارشی</li>
                                        </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.center}>
                                    <img className={classes.image} src="/assets/images/tour-3.jpg" />
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>تعرفه</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        برگزاری نمایشگاه شامل هزینه اولیه راه اندازی به علاوه هزینه هر غرفه که متناسب با امکانات انتخابی محاسبه خواهد شد. برای اطلاعات بیشتر با ما تماس بگیرید.
                                    </p>
                                </div>
                                <br />
                                <div className={classes.center}>
                                    <Button variant="outlined" href="/ContactUs" disableElevation>
                                        جهت دریافت راهنمایی و مشاوره، با متخصصان ما تماس بگیرید.
                                    </Button>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
